<template>
    <div>
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Learner House Mapping</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-row justify="center">
                <v-col cols="12" sm="4" md="4">
                  <v-icon color="error">*</v-icon>
                    <v-text-field outlined rounded color="#0F2027" dense placeholder="Enter PRN No" v-model="selected_children" type="text" hint="For example :: 121/111" @click="show = false" @change="addHouse"></v-text-field>
                </v-col>
                 <v-col cols="12" sm="4" md="4" v-if="house_list!=''">
                 <v-icon color="error">*</v-icon>
                    <v-autocomplete class="" color="#0f2027" rounded v-model="house" :items="house_list" label="Select house" item-text="name" item-value="id" outlined dense></v-autocomplete>
                </v-col>
                    <v-btn class="button mt-9" v-if="house!=null && house_list!=''" @click="addHouse()">Add House</v-btn>
            </v-row>
            <v-row dense class="box" v-if="learner_house!=null">
            <strong> Already Mapped House :: </strong> {{learner_house}}
            </v-row>
        </v-card>
        </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    export default {
        data: () => ({
            house_list: [],
            house:null,
            show: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: true,
            search: "",
            s3url: "",
            loader: false,
            selected_children:null,
            learner_house:null,
        }),
        methods: {
          addHouse(){
                const formData = {
                  registration_no: this.selected_children,
                  house : this.house
                };
                axios
                    .post("/Admission/addHouse", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.status == "NO") {
                                this.showSnackbar("#b71c1c", res.data.msgg); // show snackbar on error
                                return
                            }
                            this.learner_house = res.data.learner_house
                             if (res.data.status == "YES") {
                                this.showSnackbar("#4caf50", "House Map Successfully..."); // show snackbar on success
                                 this.onload()
                                 this.selected_children = null
                                  this.learner_house = null
                            }
                            
                          
                        }  
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        this.house = null;
                        
                        //alert("done")
                    });
          },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload(){
                this.loader=true
                axios
                .post("/Admission/learnerHouseMapping")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if ((res.data.status == "SUCCESS")) {
                            this.house_list = res.data.house_list;
                        } else {
                            alert(res.data.status_reason);
                        }
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    this.loader = false;
                });
            }
        },

        mounted() {
            this.onload()
        },
    };
</script>

<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
